import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import HtmlToReact from 'html-to-react';
let htmlToReactParser = new HtmlToReact.Parser(React);
import { redirectToInternalLink } from '../../../../businessLogic/redirector.js';
import { showModal, updateShowCreateWaitingAreaModal } from '../../../../actions/modal';
import { selectWaitingArea, updateWaitingAreasSearch } from '../../../../actions/waitingArea.js';
import { updateSearchColumn } from '../../../../actions/shared.js';
import WaitingAreaFormPage from '../../../../containers/WaitingAreaFormPage.js';
import { updateShowQuickViewModal } from '../../../../actions/modal';
import { getMinuteDiff } from '../../../helpers/date';
import { compareWaitingArea } from '../../../../reducers/waitingArea';
import { previousPage } from 'actions/navigationBar';
import { NetworkTypes } from '../../../../constants/networkTypes.js';
import { Media } from '../../../../mediaSetting';
import { Container } from 'semantic-ui-react';

export default function ViewAllWaitingAreaCenterPanel(props) {
  const fetchingOrganisationsWereIcanCreateWaitingAreas = useSelector(
    (state) => state.waitingAreaReducer.fetchingOrganisationsWereIcanCreateWaitingAreas
  );
  const organisationsWereIcanCreateWaitingAreas = useSelector(
    (state) => state.waitingAreaReducer.organisationsWereIcanCreateWaitingAreas
  );
  const canCreateWaitingAreas = useSelector((state) => state.waitingAreaReducer.canCreateWaitingAreas);
  const fetchingWaitingAreas = useSelector((state) => state.waitingAreaReducer.fetchingWaitingAreas);
  const asOfNow = useSelector((state) => state.sharedReducer.asOfNow);
  const isGroupConsultationFeatureEnabled = useSelector(
    (state) => state.usersReducer.isGroupConsultationFeatureEnabled
  );

  const dispatch = useDispatch();
  const updateWaitingAreasSearchWithInComponent = (e) => {
    if (e.target != undefined) dispatch(updateWaitingAreasSearch(e.target.value));
    else dispatch(updateWaitingAreasSearch(e));
    dispatch(updateSearchColumn(null));
  };

  const goToWaitingAreas = () => {
    let show = false;
    dispatch(updateShowQuickViewModal(show));
    dispatch(previousPage(APP.LANGUAGE.ViewOneWaitingArea.Title));

    if (props.waitingAreasFiltered.length + props.waitingAreasGray.length == 1) {
      //if the total of waiting areas is 1, then redirect to that specific waiting area
      let foundWaitingArea = null;
      if (props.waitingAreasFiltered.length > 0) foundWaitingArea = props.waitingAreasFiltered[0];
      else foundWaitingArea = props.waitingAreasGray[0];
      redirectToInternalLink('waiting-area/view-one/' + foundWaitingArea.id);
    } else {
      redirectToInternalLink('waiting-area/view-all');
    }

    if (props.loggedInUserHandler) props.loggedInUserHandler();
  };

  const showAddWaitingAreaModal = () => {
    let show = true;
    dispatch(updateShowCreateWaitingAreaModal(show));
  };

  const getColorAttended = (val) => {
    if (val == 0) return 'color-light-dark-gray';
    else return 'waiting-area-green';
  };

  const getColorWaiting = (val, redLimit = 5) => {
    if (val <= 0) return 'color-light-dark-gray';
    else if (val < redLimit) return 'waiting-area-orange';
    else return 'waiting-area-red';
  };

  const getColorIdle = (val) => {
    if (val == 0) return 'color-light-dark-gray';
    else return 'waiting-area-red';
  };

  const getColorLongestWait = (
    val,
    isParticipantsWaiting,
    redLimit = window.APP.CONFIGURATION.EscalationOfWaitingFromOrangeIntoRed
  ) => {
    if (val <= 0 && !isParticipantsWaiting) return 'color-light-dark-gray';
    else if (val <= 0 && isParticipantsWaiting) return 'waiting-area-orange';
    else if (val < redLimit) return 'waiting-area-orange';
    else return 'waiting-area-red';
  };

  const getMinute = (minutes) => {
    if (minutes > 0 && minutes < 2) return APP.LANGUAGE.ViewWaitingArea.Minute;
    else if (minutes > 1 || minutes == 0) return APP.LANGUAGE.ViewWaitingArea.Minutes;
  };

  const onWaitingAreaClick = (waitingAreaId) => {
    dispatch(previousPage(APP.LANGUAGE.ViewOneWaitingArea.Title));
    redirectToInternalLink('waiting-area/view-one/' + waitingAreaId);
  };

  let totalPeopleWaiting = 0;
  let totalIdleCalls = 0;
  let longestWait = 0;
  let totalPeopleBeingAttended = 0;
  let totalWaitingAreasOccupied = 0;
  let allThePeopleInWaitingAreas = 0;

  let renderWaitingAreas = (gray) => {
    let opaqued = gray;
    let iterator = gray ? props.waitingAreasGray : props.waitingAreasFiltered;

    if (iterator.length > 0) {
      // Sort the WAs everytime of rendering
      iterator.sort(compareWaitingArea);
    }

    return iterator.map((o, i) => {
      let topSection = (
        <span>
          <div className="ui statistics waiting-area-statistics ">
            <div className="statistic left-top mrbm">
              <div className={getColorWaiting(o.callSummary.peopleWaiting) + ' value'}>
                {o.callSummary.peopleWaiting}
              </div>
              <div className="color-light-black label">{APP.LANGUAGE.ViewWaitingAreas.Waiting}</div>
            </div>
            <div
              className={
                'statistic right-top mrbm ' + (o.networkTypeId === NetworkTypes.GroupConsultation ? 'gcIdleLabel' : '')
              }
            >
              <div className={getColorIdle(o.callSummary.peopleIdle) + ' value'}>
                {o.networkTypeId === NetworkTypes.GroupConsultation && o.callSummary.peopleIdle > 0
                  ? 1
                  : o.callSummary.peopleIdle}
              </div>
              <div className=" color-light-black label">
                {o.networkTypeId === NetworkTypes.GroupConsultation
                  ? APP.LANGUAGE.ViewWaitingAreas.GroupIdle
                  : APP.LANGUAGE.ViewWaitingAreas.Idle}
              </div>
            </div>
            <div className="statistic bottom-center mrbm">
              <input
                readOnly
                className={
                  getColorLongestWait(
                    getMinuteDiff(asOfNow, o.callSummary.calculatedLongestWaitFrom),
                    o.callSummary.peopleWaiting > 0
                  ) + ' text value minutes-hacky-input hand'
                }
                type="text"
                value={getMinuteDiff(asOfNow, o.callSummary.calculatedLongestWaitFrom)}
              />
              <div className="color-light-black label left-text mrll">
                {getMinute(getMinuteDiff(asOfNow, o.callSummary.calculatedLongestWaitFrom))}
              </div>
              <div className="color-light-black label mrll left-text  longest-wait">
                {APP.LANGUAGE.ViewWaitingAreas.LongestWait}
              </div>
            </div>
          </div>
          <div className="ui horizontal statistic waiting-area-bottom-statistics mrbxs ">
            <div className={getColorAttended(o.callSummary.peopleBeingAttended) + ' value bold'}>
              {o.networkTypeId === NetworkTypes.GroupConsultation && o.callSummary.peopleBeingAttended > 0
                ? 1
                : o.callSummary.peopleBeingAttended}
            </div>
            <div className="label color-light-black mrlxs">
              {o.networkTypeId === NetworkTypes.GroupConsultation
                ? APP.LANGUAGE.ViewWaitingAreas.GroupActive
                : APP.LANGUAGE.ViewWaitingAreas.Attended}
            </div>
          </div>
        </span>
      );

      return (
        <div
          key={o.id}
          className="ui waiting-area shape pdrxs pdlxs mrbm invisible-to-full"
          onClick={() => {
            onWaitingAreaClick(o.id);
          }}
        >
          <div className="sides">
            <div className="active side">
              <div className="ui card border-radius-null borderless" data-opaque={opaqued}>
                <div className="content" data-is-filtered={props.waitingAreasGray.length > 0}>
                  {/*<i className="ui icon genderless  mrts mrbnull color-button-on-text color-button-on-text-hover text-size-l"></i>*/}
                  {topSection}
                  {o.networkTypeId === NetworkTypes.GroupConsultation && !isGroupConsultationFeatureEnabled ? (
                    <div className="waiting-area-black-bg wa-status-message">
                      {APP.LANGUAGE.ViewWaitingAreas.GroupConsultationInactive}
                    </div>
                  ) : o.isSuspended ? (
                    <div className="waiting-area-red-bg wa-status-message">Caller access suspended</div>
                  ) : (
                    ''
                  )}
                  <div className="mid-bottom-info-container normal-message-spacing">
                    <div
                      className={
                        'center-text pdts pdbs pdrxs pdlxs wa-name-wrapper flex-like center-with-flex ' +
                        (o.networkTypeId === NetworkTypes.GroupConsultation ? 'group-consultation' : '')
                      }
                    >
                      <div
                        className={
                          'waiting-area-name ' +
                          (o.name.length > 32 ? 'reduced-waiting-area-name-size' : 'normal-waiting-area-name-size')
                        }
                      >
                        {o.name}
                      </div>
                    </div>
                    {o.networkTypeId === NetworkTypes.GroupConsultation ? (
                      <div className={'group-consultation-pill'}>
                        <div className="span-like group-consultation-text" style={{ whiteSpace: 'nowrap' }}>
                          {APP.LANGUAGE.EntityAdmin.GroupConsultation}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    <div className="organisation-name-label">
                      <div>{o.organisationAbbreviatedName}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };
  let areThereWaitingAreasAndWeArentFetching =
    !fetchingWaitingAreas || props.waitingAreasFiltered.length > 0 || props.waitingAreasGray.length > 0;
  const renderInQuickViewMode = props.noHeader;
  let waitingAreasHtml = '';
  let newWaitingAreaCard = '';
  let waitingAreasNotMatchingFilter = '';

  if (!renderInQuickViewMode && areThereWaitingAreasAndWeArentFetching) {
    waitingAreasHtml = renderWaitingAreas(false);
    waitingAreasNotMatchingFilter = renderWaitingAreas(true);
  } else if (renderInQuickViewMode && areThereWaitingAreasAndWeArentFetching) {
    props.waitingAreasFiltered.map((o, i) => {
      let summary = o.callSummary;
      allThePeopleInWaitingAreas +=
        parseInt(summary.peopleWaiting) + parseInt(summary.peopleIdle) + parseInt(summary.peopleBeingAttended);
      totalPeopleWaiting += parseInt(summary.peopleWaiting);
      totalIdleCalls += parseInt(summary.peopleIdle);
      totalPeopleBeingAttended += parseInt(summary.peopleBeingAttended);

      if (getMinuteDiff(asOfNow, o.callSummary.calculatedLongestWaitFrom) > longestWait)
        //pick the greates longest wait out of all the waiting areas
        longestWait = getMinuteDiff(asOfNow, o.callSummary.calculatedLongestWaitFrom);
      if (
        getMinuteDiff(asOfNow, o.callSummary.calculatedLongestWaitFrom) > 0 ||
        parseInt(summary.peopleWaiting) > 0 ||
        parseInt(summary.peopleIdle) > 0 ||
        parseInt(summary.peopleBeingAttended) > 0
      )
        totalWaitingAreasOccupied += 1;
    });

    waitingAreasHtml = (
      <div onClick={goToWaitingAreas} className="ui waiting-area  shape pdrxs pdlxs mrtm invisible-to-full">
        <Container fluid as={Media} greaterThanOrEqual="tablet" className="sides responsive">
          <div className="active side">
            <div className="ui card border-radius-null borderless">
              <div className="content hand" data-is-filtered={props.waitingAreasGray.length > 0}>
                {/*<i className="ui icon genderless  mrts mrbnull color-button-on-text color-button-on-text-hover text-size-l"></i>*/}
                <div className="ui statistics waiting-area-statistics pdtxs hand">
                  <div className="statistic left-top mrbm">
                    <div className={getColorWaiting(totalPeopleWaiting) + ' value hand'}>{totalPeopleWaiting}</div>
                    <div className="color-light-black label hand">{APP.LANGUAGE.ViewWaitingAreas.Waiting}</div>
                  </div>
                  <div className="statistic right-top mrbm ">
                    <div className={getColorIdle(totalIdleCalls) + ' value hand'}>{totalIdleCalls}</div>
                    <div className=" color-light-black label hand">{APP.LANGUAGE.ViewWaitingAreas.Idle}</div>
                  </div>
                  <div className="statistic bottom-center mrbm hand">
                    <input
                      readOnly
                      className={
                        getColorLongestWait(longestWait, totalPeopleWaiting > 0) +
                        ' text value minutes-hacky-input hand'
                      }
                      type="text"
                      value={longestWait}
                    />
                    <div className="color-light-black label left-text mrll hand">{getMinute(longestWait)}</div>
                    <div className="color-light-black label mrll left-text longest-wait hand">
                      {APP.LANGUAGE.ViewWaitingAreas.LongestWait}
                    </div>
                  </div>
                </div>
                <div className="ui horizontal statistic waiting-area-bottom-statistics mrbxs hand">
                  <div className={getColorAttended(totalPeopleBeingAttended) + ' value bold hand'}>
                    {totalPeopleBeingAttended}
                  </div>
                  <div className="label color-light-black mrlxs hand">{APP.LANGUAGE.ViewWaitingAreas.Attended}</div>
                </div>
                <div className="mid-bottom-info-container-quick-view hand">
                  <img
                    className="ui image hand mrrnull fl pdrxs mrtm header-icon"
                    src={APP.IMAGES.WaitingAreaIcon.default}
                  />
                  <div className="description  pdrxs pdlxs light mrtm hand">
                    {totalWaitingAreasOccupied == 1 ? (
                      <span className="hand">{APP.LANGUAGE.ViewOneWaitingArea.AreaInUse}</span>
                    ) : (
                      htmlToReactParser.parse(
                        '<span className="hand">' +
                          APP.LANGUAGE.ViewOneWaitingArea.AreasInUse.replace(
                            '##count##',
                            '<span className="bold hand">' + totalWaitingAreasOccupied + '</span>'
                          ) +
                          '</span>'
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
        {renderInQuickViewMode ? (
          <Container fluid as={Media} at="mobile" className="waiting-area-quick-view-small">
            <div className="display-flex center-flex center-with-flex mrtm mrbs">
              <div className="display-flex center-flex mrrl">
                <div className={getColorWaiting(totalPeopleWaiting) + ' text-size-xxl mrrxs'}>{totalPeopleWaiting}</div>
                <div>{APP.LANGUAGE.ViewWaitingArea.QuickViewSmallPeopleWaiting}</div>
              </div>
              <div className="display-flex center-flex">
                <div className={getColorIdle(totalIdleCalls) + ' text-size-xxl mrrxs'}>{' ' + totalIdleCalls}</div>
                <div>{APP.LANGUAGE.ViewWaitingArea.QuickViewSmallPeopleIdle}</div>
              </div>
            </div>
            <div className="display-flex center-flex center-with-flex mrbs">
              <div className="display-flex center-flex">
                <div className="text-size-mms">{APP.LANGUAGE.ViewWaitingArea.QuickViewSmallLongestWait}</div>
                <div
                  className={getColorLongestWait(longestWait, totalPeopleWaiting > 0) + ' text-size-xxl mrrxxs mrlxxs'}
                >
                  {longestWait}
                </div>
                <div className="text-size-mms">{getMinute(longestWait)}</div>
              </div>
            </div>

            <div className="display-flex center-flex center-with-flex mrbm">
              <div className="display-flex center-flex">
                <div className={getColorAttended(totalPeopleBeingAttended) + ' text-size-xxl mrrxs'}>
                  {totalPeopleBeingAttended}
                </div>
                <div>{APP.LANGUAGE.ViewWaitingArea.QuickViewSmallPeopleAttended}</div>
              </div>
            </div>
            <div className="display-flex center-flex center-with-flex mid-bottom-info-container-quick-view">
              {totalWaitingAreasOccupied == 1
                ? APP.LANGUAGE.ViewOneWaitingArea.AreaInUse
                : APP.LANGUAGE.ViewOneWaitingArea.AreasInUse.replace('##count##', totalWaitingAreasOccupied)}
            </div>
          </Container>
        ) : (
          ''
        )}
      </div>
    );
  }

  if (fetchingWaitingAreas && props.waitingAreasFiltered.length == 0 && props.waitingAreasGray.length == 0) {
    waitingAreasHtml = (
      <div className="ui waiting-area shape pdrxs pdlxs mrtm invisible-to-full">
        <div className="ui active inverted dimmer ">
          <div className="ui text loader  " />
        </div>
        <div className="sides mihtpxlll">
          <div className="active side">
            <div className="ui card border-radius-null borderless">
              <div className="content">
                {/*<i className="ui icon genderless  mrts mrbnull color-button-on-text color-button-on-text-hover text-size-l"></i>*/}
                <div className="ui statistics waiting-area-statistics mrtm ">
                  <div className="statistic left-top color-gray-bg color-gray">
                    <div className=" value color-gray-bg color-gray">0</div>
                    <div className="color-gray-bg color-gray">asdasd</div>
                  </div>
                  <div className="statistic right-top color-gray-bg color-gray">
                    <div className=" value color-gray-bg color-gray">0</div>
                    <div className=" color-gray-bg color-gray">asdasd</div>
                  </div>
                  <div className="statistic bottom-center mrbm color-gray-bg ">
                    <input readOnly className=" text value minutes-hacky-input  hand " type="text" value="" />
                    <div className="color-light-black left-text mrll color-gray mrlm">asddasd</div>
                    <div className="color-light-black mrll left-text longest-wait color-gray mrlm">asdasd</div>
                  </div>
                </div>
                <div className="ui horizontal statistic waiting-area-bottom-statistics mrbs   color-gray-bg color-gray">
                  <div className="value  color-gray-bg color-gray mrlxxl pdlm">0</div>
                </div>
                <div className="description center-text   pdrxs pdlxs no-bold color-gray-bg color-gray htxl mrtl" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (!renderInQuickViewMode && !fetchingOrganisationsWereIcanCreateWaitingAreas && canCreateWaitingAreas) {
    newWaitingAreaCard = (
      <div
        className="ui waiting-area shape pdrxs pdlxs mrbm invisible-to-full fade-in"
        onClick={() => showAddWaitingAreaModal()}
      >
        <div className="sides">
          <div className="active side">
            <div className="ui card border-radius-null borderless">
              <div className="content display-flex center-with-flex">
                <i className="ui icon circular plus text-size-lll color-good-things-text waiting-area-add" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  let modals = '';
  if (!props.noHeader) {
    modals = (
      <span>
        <WaitingAreaFormPage updateOrInsert="insert" />
      </span>
    );
  }

  let textInputToDisplay = '';

  if (props.currentWaitingAreasFilter.indexOf('¤') > -1) {
    let valueToDisplay = props.currentWaitingAreasFilter.split('¤')[1];
    textInputToDisplay = (
      <div className="ui transparent icon input color-white pdls center-flex">
        <div className="ui  label mrrxl hide-on-small-ress">
          {valueToDisplay.length > 10 ? valueToDisplay.substring(0, 10) + '...' : valueToDisplay}
          <i
            onClick={() => {
              updateWaitingAreasSearchWithInComponent('');
            }}
            className="delete icon"
          />
        </div>
        <button className="ui icon button show-on-small-ress mrrxl ">
          <i
            className="delete icon"
            onClick={() => {
              updateWaitingAreasSearchWithInComponent('');
            }}
          />
        </button>
        <i className="filter icon mrrs" />
      </div>
    );
  } else {
    textInputToDisplay = (
      <div className="ui transparent icon input color-white color-waiting-area-bg-highlight  center-flex">
        <input
          type="text"
          className="color-white color-waiting-area-bg-highlight pdxs  hide-on-small-ress"
          onChange={(e) => updateWaitingAreasSearchWithInComponent(e)}
          value={props.currentWaitingAreasFilter}
          placeholder={APP.LANGUAGE.ViewWaitingArea.WaitingAreaPlaceholder}
          style={{ fontSize: '1rem' }}
        />
        <input
          type="text"
          className="color-white show-on-small-ress color-waiting-area-bg-highlight pdlxs pdtxs"
          onChange={(e) => updateWaitingAreasSearchWithInComponent(e)}
          value={props.currentWaitingAreasFilter}
          placeholder={APP.LANGUAGE.ViewWaitingArea.WaitingAreaPlaceholder}
        />

        <i className="filter icon mrrs" />
      </div>
    );
  }

  return (
    <div>
      {modals}
      <div className="ui  aligned padded grid ">
        <div
          className="row flexible  color-waiting-area-bg pdtnull pdbnull mrbm header-row pdlnull "
          data-show={!props.noHeader}
        >
          <div className="ui transparent large fluid icon input color-white   waiting-areas-filter">
            <div className=" ui transparent  fluid icon input color-white   column  display-flex color-white hide-on-small-ress left-text">
              {textInputToDisplay}
            </div>
          </div>
        </div>
      </div>
      <div className={props.isOnMobileOrTablet && !props.isInQuicKView ? 'shapes-wrapper mrlm mrrm' : 'shapes-wrapper'}>
        <div className="shape-columns " data-rendered-as-preview={props.noHeader}>
          {waitingAreasHtml}
          {waitingAreasNotMatchingFilter}
          {newWaitingAreaCard}
        </div>
      </div>
    </div>
  );
}
